import { tuple } from './type'; // eslint-disable-next-line import/prefer-default-export

export var PresetColorTypes = tuple('pink', 'red', 'yellow', 'orange', 'cyan', 'green', 'blue', 'purple', 'geekblue', 'magenta', 'volcano', 'gold', 'lime');


//////////////////
// WEBPACK FOOTER
// ../~/antd/es/_util/colors.js
// module id = 300
// module chunks = 0